"use client";

import { Box, Grid, GridItem, Heading, useMediaQuery } from "@chakra-ui/react";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { HoverCard, HoverCardProps } from "@ui/components/hover-card";
import { FAQSection, Faqs_T } from "@ui/marketing/faq/faq";
import { SectionTemplate } from "components/individuals/blocks";
import Image from "next/image";
import { customRichText } from "./individuals/mdx-components";

export interface ClientEmpowerCardsSectionProps {
  title: string;
  subtitle: string;
  textColor: string;
  bg: string;
  infoCards: HoverCardProps[];
  faqSection: Omit<Faqs_T, "renderAnswer">;
}

export const ClientEmpowerCardsSection = ({
  title,
  subtitle,
  textColor,
  bg,
  infoCards,
  faqSection,
}: ClientEmpowerCardsSectionProps) => {
  const [isLargeBp] = useMediaQuery("(min-width: 992px)");
  return (
    <SectionTemplate bg={bg} color={textColor}>
      <Heading
        as={"h1"}
        fontSize={{
          base: 26,
          md: 34,
          lg: 38,
          xl: 45,
        }}
        lineHeight={1.2}
        fontWeight={"bold"}
        mb={{
          base: 8,
          lg: 12,
        }}
        textAlign={"left"}
        w={{
          lg: "80%",
        }}
      >
        {title}
      </Heading>
      <Heading
        as={"h2"}
        fontSize={{
          base: 16,
          md: 20,
          xl: 22,
        }}
        fontWeight={"semibold"}
        mb={{
          base: 0,
          lg: 14,
        }}
        textAlign={"left"}
        w={{
          lg: "85%",
        }}
      >
        {subtitle}
      </Heading>

      {isLargeBp ? (
        <Grid templateColumns={"repeat(3, 1fr)"} columnGap={12} rowGap={8}>
          {infoCards.map((card, idx) => (
            <GridItem key={idx}>
              {card.icon && (
                <Box w={"120px"} mx={"auto"} mb={5}>
                  <Image
                    src={card.icon.url}
                    width={120}
                    height={58}
                    alt={card.icon?.alt}
                    placeholder={
                      typeof card.icon?.blurDataURL === "string"
                        ? "blur"
                        : undefined
                    }
                    blurDataURL={
                      typeof card.icon?.blurDataURL === "string"
                        ? card.icon?.blurDataURL
                        : undefined
                    }
                  />
                </Box>
              )}
              <HoverCard {...card} />
            </GridItem>
          ))}
        </Grid>
      ) : (
        <FAQSection
          renderAnswer={(answer) => (
            <RichText
              content={answer?.raw}
              renderers={customRichText(undefined, undefined, undefined, {
                base: "15px",
              })}
            />
          )}
          {...faqSection}
        />
      )}
    </SectionTemplate>
  );
};
